/* GET NAILS - Galeria sectiunii Despre noi 07. Compatibila cu Shopify Customize. */
(function () {
  'use strict';

  if (window.__gnRecommendedProductsBound) return;
  window.__gnRecommendedProductsBound = true;

  var rootSelector = '[data-gn-recommended-root]';
  var slideSelector = '[data-gn-recommended-slide]';
  var thumbSelector = '[data-gn-recommended-thumb]';
  var dotSelector = '[data-gn-recommended-dot]';

  function elements(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function getIndex(root) {
    var thumbs = elements(root, thumbSelector);
    var index = thumbs.findIndex(function (thumb) {
      return thumb.getAttribute('aria-current') === 'true';
    });
    return Math.max(index, 0);
  }

  function setIndex(root, requestedIndex) {
    var slides = elements(root, slideSelector);
    if (!slides.length || !Number.isFinite(requestedIndex)) return;
    var index = ((requestedIndex % slides.length) + slides.length) % slides.length;

    slides.forEach(function (slide, i) {
      slide.hidden = i !== index;
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    var thumbs = elements(root, thumbSelector);
    thumbs.forEach(function (thumb, i) {
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    elements(root, dotSelector).forEach(function (dot, i) {
      dot.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });

    var status = root.querySelector('[data-gn-recommended-status]');
    if (status) status.textContent = 'Fotografia ' + (index + 1) + ' din ' + slides.length;

    var strip = root.querySelector('.gn-about-recommended__thumbnails');
    var thumb = thumbs[index];
    if (strip && thumb) {
      var parent = strip.getBoundingClientRect();
      var selected = thumb.getBoundingClientRect();
      if (selected.left < parent.left) {
        strip.scrollLeft += selected.left - parent.left - 4;
      } else if (selected.right > parent.right) {
        strip.scrollLeft += selected.right - parent.right + 4;
      }
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-gn-recommended-prev], [data-gn-recommended-next], [data-gn-recommended-thumb], [data-gn-recommended-dot]');
    if (!button) return;
    var root = button.closest(rootSelector);
    if (!root) return;

    var index = getIndex(root);
    if (button.hasAttribute('data-gn-recommended-thumb') || button.hasAttribute('data-gn-recommended-dot')) {
      index = Number.parseInt(button.getAttribute('data-gn-recommended-index'), 10);
    } else if (button.hasAttribute('data-gn-recommended-prev')) {
      index -= 1;
    } else {
      index += 1;
    }
    setIndex(root, index);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var active = event.target;
    if (!active || !active.closest) return;
    var thumb = active.closest(thumbSelector);
    if (!thumb) return;
    var root = thumb.closest(rootSelector);
    if (!root) return;
    var thumbs = elements(root, thumbSelector);
    if (thumbs.length <= 1) return;
    var index = thumbs.indexOf(thumb);
    if (index < 0) return;
    event.preventDefault();
    index = (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
    setIndex(root, index);
    thumbs[index].focus();
  });

  document.addEventListener('shopify:block:select', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var thumb = event.target.matches && event.target.matches(thumbSelector)
      ? event.target
      : event.target.querySelector(thumbSelector);
    if (!thumb) return;
    var root = thumb.closest(rootSelector);
    if (root) setIndex(root, Number.parseInt(thumb.getAttribute('data-gn-recommended-index'), 10));
  });
}());
